var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { checkIfSearchable, useResourceSearchDropdown, } from 'ziphy-web-shared/basic/entities/notes/resources';
import { Dropdown, DropdownContent } from 'ziphy-web-shared/basic/lib/functional';
import { useInitialSelected, useSelectMacroDropdown } from '../../../../Notes.hooks';
import { useTextBlockContext } from '../../TextBlock.context';
import styles from './TextBlockInput.module.scss';
const TextBlockInput = ({ $section, macrosList, id, value, onAddMacro, isBlocked, onClose, }) => {
    const $store = useTextBlockContext();
    const { dropdown, macro, setMacro, isMulti, triggerModal } = useSelectMacroDropdown({
        $section,
        macrosList,
        onSelect: useCallback((macroId) => __awaiter(void 0, void 0, void 0, function* () {
            $store.EDIT_INPUT_ELEMENT(id, { macroId });
            yield onAddMacro();
        }), [$section.id]),
    });
    const initialSelected = useInitialSelected(macro);
    const onSelectResource = useCallback((fhirRef) => __awaiter(void 0, void 0, void 0, function* () {
        const refAsString = Array.isArray(fhirRef) ? fhirRef.join(',') : fhirRef;
        if (refAsString) {
            $store.EDIT_INPUT_ELEMENT(id, { macroId: macro.id, fhirRef: refAsString });
            yield onAddMacro();
        }
        $store.deleteInput(id);
    }), [macro]);
    const { resourceSearchDropdown, isAddingNew, selectedItems, handleOnDone, handleOnReset, handleOnRemoveAll, handleOnRemove, contentMountEventName, openResourceModal, } = useResourceSearchDropdown({
        encounterId: $section.encounterId,
        resourceContext: macro === null || macro === void 0 ? void 0 : macro.properties,
        initialSelected,
        isMulti,
        practiceSettings: $section.practiceSettings,
        onSelectResource,
    });
    useEffect(() => dropdown.setSearchString(value.slice(1)), [value]);
    useEffect(() => !dropdown.dropdownRef.current.isOpen && dropdown.dropdownRef.current.onOpen(), []);
    const isSearchable = macro ? checkIfSearchable(macro.properties.searchPreference) : null;
    useEffect(() => isSearchable === false && openResourceModal(''), [triggerModal]);
    if (dropdown.totalItems === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(Dropdown, Object.assign({ ref: dropdown.dropdownRef, renderButton: ({ fieldRef }) => (_jsx("span", Object.assign({ id: id, ref: fieldRef, onClick: (e) => e.preventDefault(), className: classNames(styles.input, isBlocked && styles.inputBlocked), "data-input": true, contentEditable: true, suppressContentEditableWarning: true }, { children: value }))), onClickOutside: isAddingNew ? () => { } : undefined, onOpen: () => {
            if (!macro && dropdown.totalItems === 1) {
                const first = dropdown.filteredItems[0].items[0];
                if (first.extra.type === 'resource')
                    first.onClick();
            }
        }, onAfterClose: () => {
            $store.deleteInput(id);
        }, className: styles.dropdown, resizeDeps: [
            macro === null || macro === void 0 ? void 0 : macro.id,
            dropdown.searchString,
            dropdown.totalFilteredItems,
            resourceSearchDropdown.searchString,
            resourceSearchDropdown.totalFilteredItems,
        ] }, { children: isSearchable ? (_jsx(DropdownContent, { searchField: {
                value: resourceSearchDropdown.searchString,
                onChange: resourceSearchDropdown.setSearchString,
            }, isLoading: resourceSearchDropdown.isLoading, items: resourceSearchDropdown.filteredItems, isManualCloseControl: true, isMulti: isMulti, 
            // selectedItems={selectedItems}
            onDone: handleOnDone, onRemoveAll: handleOnRemoveAll, onRemoveItem: handleOnRemove, mountEventName: contentMountEventName, onOpen: () => {
                if (!isMulti && (initialSelected === null || initialSelected === void 0 ? void 0 : initialSelected.length)) {
                    onSelectResource(initialSelected);
                    $store.deleteInput(id);
                }
            } }, 'resources')) : (_jsx(DropdownContent, { isManualCloseControl: true, items: dropdown.filteredItems }, 'marcos')) })));
};
export default observer(TextBlockInput);
